<template>
  <vue-datamaps
    aws-regions
    arc
    :arc-config="arcConfig"
    :aws-regions-config="awsRegionsConfig"
    :geography-config="geographyConfig"
    :fills="fills"
    class="-my-20"
    @custom:popup-region="customPopupRegion"
    @click:aws-region="handleRegionClick"
  >
    <template v-if="hoverData.name" #hoverRegionInfo>
      <div class="hoverinfo">
        <div class="font-semibold">
          {{ hoverData.name }}
        </div>
        <div class="text-xs text-gray-500">
          {{ hoverData.city }}, {{ hoverData.country }}
        </div>
      </div>
    </template>
  </vue-datamaps>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { VueDatamaps } from 'vue3-datamaps';

const props = defineProps({
  dataCenters: {
    type: Array,
    required: true
  }
});

const router = useRouter();

const geographyConfig = {
  borderColor: 'var(--color-lime-500)',
  highlightFillColor: 'var(--color-lime-200)',
  highlightBorderColor: 'var(--color-lime-600)',
  highlightBorderWidth: 1,
  highlightOnHover: true,
  popupOnHover: false
};

const fills = {
  defaultFill: 'var(--color-lime-100)',
  enabled: 'var(--color-lime-600)',
  disabled: 'var(--color-red-500)'
};

const awsRegionsConfig = computed(() => ({
  data: props.dataCenters.map(dc => ({
    code: idToCode(dc.id),
    fillKey: dc.isEnabled ? 'enabled' : 'disabled'
  })),
  popupTemplate: true,
  popupOnHover: true,
  showPrivateRegions: true,
  borderColor: 'var(--color-gray-500)',
  borderWidth: 1,
  region: props.dataCenters.map(dc => ({
    id:dc.id,
    code: idToCode(dc.id),
    name: dc.name,
    city: dc.city,
    country: dc.country,
    coordinates: {
      latitude: dc.latitude,
      longitude: dc.longitude
    }
  }))
}));

const arcConfig = computed(() => {
  const data = [];
  for (const dc of props.dataCenters) {
    for (const dc2 of props.dataCenters) {
      if (dc.id > dc2.id) {
        if (!dc.isEnabled || !dc2.isEnabled) {
          // Only draw arcs between enabled data centers
          continue;
        }
        data.push({
          origin: idToCode(dc.id),
          destination: idToCode(dc2.id),
          color: 'var(--color-gray-500)'
        });
      }
    }
  }

  return {
    data,
    popupOnHover: false,
    popupTemplate: false,
    arcSharpness: 1.2,
    animationSpeed: 300
  };
});

function idToCode(id) {
  return `aws-${id}`;
}

const hoverData = ref({});

function customPopupRegion({ datum }) {
  hoverData.value = datum;
}

function handleRegionClick(item) {
  router.push(`/data-center/${item.id}`);
};
</script>
